module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "youtube.73dfde61.svg";